import React from "react";
import { Space } from "antd";
import User from "../../components/User";
import Tourney from "./Tourney";
import {pp} from "@/utils.js";

let WithTitle = ({ title, extra, itemsStart = false }) => {
  if (!User.operator || Tourney.done)
    return null;

  pp(title)

  // Handle array of extra items and filter out falsy values
  const extraItems = Array.isArray(extra) ? extra.filter(Boolean) : extra;

  return <div className="pb-4">
    <div className={`flex justify-between mb-4 ${itemsStart ? 'items-start' : 'items-center'}`}>
      <h1 className="text-2xl font-bold">{title}</h1>
      {extraItems && <Space>{extraItems}</Space>}
    </div>
  </div>
};

export default WithTitle;